import styled from 'styled-components';
import { ShimmerEffect } from '../../CartOverlayContainer/Cart/BackPopupCart/styled';

export const Hemburger = styled.div`
  display: none;
  padding-right: ${(props) =>
    props.paddingRight ? props.paddingRight : 'initial'};
  @media (max-width: 720px) {
    display: block;
  }
`;

export const Header = styled.div`
  background: #fff;
  height: 56px;
  position: fixed;
  z-index: 99;
  box-shadow: 0 3px 6px 0 #00000029;
  width: 100%;
  padding: 0 14px;
  top: 0;
`;

export const HeaderCentered = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr;
  align-items: center;
  height: 100%;
  max-width: 1100px;
  margin: auto;

  @media (max-width: 720px) {
    grid-template-columns: 60px 100px 1fr;
  }
`;

export const HeaderLogo = styled.img`
  width: 96px;
  height: 32px;
  cursor: pointer;
`;
export const HeaderLogoSprite = styled.span`
  & svg {
    width: 96px;
    height: 32px;
    cursor: pointer;
  }
`;

export const Rightinheader = styled.div`
  margin-left: auto;
`;

export const HeaderCart = styled.span`
  zoom: ${(props) => props.zoom};
  margin: 0 11px;
  cursor: pointer;
`;
export const MainContainer = styled.div`
  max-width: ${(props) => (props.fullWidth ? '100%' : '85%')};
  margin: 0 auto;
  padding-top: ${(props) =>
    props.marquee ? '90px' : props.paddingTop ? props.paddingTop : '90px'};
  background: #fff;

  @media (max-width: 720px) {
    max-width: 100%;
    background: none;
    padding-top: ${(props) =>
      props.showHeader == '-56px'
        ? '32px'
        : props.noPadding
          ? '0px'
          : props.subCategory || props.pdpHideHeader
            ? '70px'
            : props.isDiaperSku
              ? '119px'
              : '65px'};
  }
`;

export const FooterContainer = styled.div`
  padding-top: ${(props) => (props.hideHeader ? '56px ' : '0px')};
  margin-bottom: 40px;
`;
export const PdpMarquee = styled.div`
  font-size: 12px;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.24px;
  ${ShimmerEffect}
  text-align: ${(props) => (props.article ? 'left' : 'center')};
  color: ${(props) =>
    props.textCarousel
      ? '#fff'
      : props.isMaternityPage
        ? '#F49710'
        : 'hsl(0deg, 0%, 0%, 87%)'};
  height: 32px;
  background-color: ${(props) =>
    props.textCarousel
      ? '#000000d6'
      : props.background
        ? props.background
        : 'rgba(0, 0, 0, 0.84)'};
  overflow: hidden;
  position: relative;
  top: 0;
  @media (min-width: 768px) {
    text-align: ${(props) =>
      props.isConsult && !props.centerAlign
        ? props?.bookingDone
          ? 'center'
          : 'right'
        : 'center'};
  }
  @media (max-width: 720px) {
    top: ${(props) =>
      props.isConsult || props.oldCategory || props.results ? '0' : '65px'};
  }

  p {
    .slide_top_bottom {
      animation: fade-in 2s cubic-bezier(0.47, 0.38, 0.36, 1) infinite;
      position: relative;
    }

    @keyframes fade-in {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }

  marquee {
    display: none;
    @media (max-width: 720px) {
      display: block;
    }
  }

  &:after {
    content: '';
    position: absolute;
    right: 0;
    background: ${(props) =>
      props.textCarousel ? 'none' : 'url(/images/salestripbg.svg)'};
    width: 130px;
    height: 46px;
    background-size: 150px;
    background-repeat: no-repeat;
    top: 0;
    overflow: hidden;
    opacity: 0.6;
    display: ${(props) => (props.isConsult ? 'none' : 'block')};
    @media (max-width: 720px) {
      display: none;
    }
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    background: ${(props) =>
      props.textCarousel ? 'none' : ' url(/images/salestripbgleft.svg)'};

    width: 130px;
    height: 46px;
    background-size: 150px;
    background-repeat: no-repeat;
    top: 0;
    overflow: hidden;
    opacity: 0.6;
    display: ${(props) => (props.isConsult ? 'none' : 'block')};
    @media (max-width: 720px) {
      display: none;
    }
  }
`;

export const OtiStripAll = styled.div`
  font-size: 14px;
  line-height: 1.33;
  letter-spacing: 0.34px;
  text-align: center;
  color: rgb(0, 0, 0, 0.8);
  padding: 10px 16px;
  background-color: #fdf0bd;
  position: relative;
  top: 122px;

  @media (max-width: 720px) {
    top: ${(props) => (props.showOnTop ? '0' : '56px')};
  }
`;

export const ViewAllButton = styled.p`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.42px;
  border: none;
  color: #ef4e5e;
  text-align: center;
  padding-left: 12px;
  @media (min-width: 720px) {
    cursor: pointer;
  }
`;

export const NavBarCover = styled.div`
  transition: all 0.3s ease 0s;
  position: fixed;
  top: -55px;
  width: 100%;
  z-index: 98;
`;

export const HeaderNavbar = styled.ul`
  width: 100%;

  background: white;
  color: black;
  z-index: 99;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
  justify-items: center;
  height: 34px;
  align-items: center;
  font-size: 13px;

  & li {
    width: 100%;
    text-align: center;
  }

  & a {
    color: hsl(0deg, 0%, 0%, 46%);
    cursor: default;

    &.active {
      border-bottom: 2px solid #ef4e5e;
      color: #ef4e5e;
      display: inline-block;
      width: 100%;
      text-align: center;
      line-height: 34px;
    }
  }
`;

export const GoToTopCover = styled.div`
  position: relative;
  top: 22px;
  z-index: 1;
  left: 0;
  margin: 0 auto;
  width: 100%;
  justify-content: center;
  display: none;
  @media (max-width: 720px) {
    display: flex;
  }
`;

export const GoToTopButton = styled.button`
  align-items: center;
  display: flex;
  background-color: #ef4e5e;
  border: none;
  border-radius: 23px;
  padding: 4px 9px 3px 5px;
  color: #fff;
  font-size: 12px;

  & img {
    margin-top: -1px;
  }
`;

export const CartBox = styled.div`
  position: relative;
`;
export const CartCount = styled.span`
  position: absolute;
  left: 20px;
  bottom: 15px;
  font-size: 11px;
  color: #ef4e5e;
`;

export const SnackBar = styled.div`
  visibility: hidden;
  opacity: 0;
  width: 90%;
  max-width: 400px;
  background-color: #333;
  transform: translateX(-50%);
  color: #fff;
  text-align: center;
  border-radius: 10px;
  padding: 16px;
  position: fixed;
  z-index: 99999;
  left: 50%;
  bottom: 30px;
  font-size: clamp(12px, 15px, 2vw);
  transition:
    opacity 0.5s,
    bottom 0.5s;

  &.show {
    visibility: visible;
    opacity: 1;
    bottom: 30px;
    animation:
      fadein 0.5s,
      fadeout 0.5s 2.5s;
  }

  > span {
    padding: 12px 0 12px 12px;
    color: #ef4e5e;
    cursor: pointer;
  }

  @keyframes fadeout {
    from {
      bottom: 30px;
      opacity: 1;
    }
    to {
      bottom: 0;
      opacity: 0;
    }
  }

  @media (max-width: 720px) {
    bottom: 80px;
    &.show {
      bottom: 80px;
    }

    @keyframes fadeout {
      from {
        bottom: 80px;
        opacity: 1;
      }
      to {
        bottom: 0;
        opacity: 0;
      }
    }
  }
`;

export const SnackBarSidesheet = styled.div`
  visibility: hidden;
  position: fixed;
  width: 80%;
  max-width: 392px;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 10px;
  padding: 12px 16px;
  z-index: 9999;
  right: 12px;
  bottom: 110px;
  font-size: clamp(12px, 2vw, 14px);

  &.show {
    visibility: visible;
    animation:
      fadeinsidesheet 0.5s,
      fadeoutsidesheet 0.5s 2.5s;
  }

  &.payment {
    right: 10%;
    @media (min-width: 768px) {
      right: 50%;
    }
  }

  @keyframes fadeinsidesheet {
    from {
      bottom: 0;
      opacity: 0;
    }
    to {
      bottom: 110px;
      opacity: 1;
    }
  }

  @keyframes fadeoutsidesheet {
    from {
      bottom: 110px;
      opacity: 1;
    }
    to {
      bottom: 0;
      opacity: 0;
    }
  }
`;

export const BreadcrumbsCover = styled.div`
  display: block;
  @media (max-width: 720px) {
    display: ${(props) => (props.showBreadCrumbs ? 'block' : 'none')};
  }
`;
